import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class DeliveryTermsStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
